<template>
  <v-container>
    <v-layout>
      <v-flex xs12 md10 offset-md1>
        <v-card>
          <v-card-title>
            <v-flex>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                :return-value.sync="date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="date"
                  label="Select date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="dataTable"
            :search="search"
            :loading="!dataReady"
            v-bind:pagination.sync="pagination"
          >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td class="text-xs-right">{{ props.item.time | moment }}</td>
              <td class="text-xs-right">
                <v-chip :class="chipColor(props.item.status)" >{{ props.item.status }}</v-chip>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import { db } from '@/main.js'
import firebase from 'firebase'
export default {
  data () {
    return {
      dataReady: false,
      search: '',
      userLog: [],
      pagination: {'sortBy': 'time', 'descending': true, 'rowsPerPage': 25},
      headers: [
        {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'name'
          },
          { text: 'Updated', align: 'right', value: 'time', sortable: true },
          { text: 'Status', align: 'right', value: 'status' }
      ],
      // Date picker
      date: new Date().toISOString().substr(0, 10),
      menu: false
    }
  },
  methods: {
    chipColor (status) {
      let color = 'grey'
      switch(status) {
        case 'Offsite':
          color = 'green'
          break
        case 'Onsite G2':
          color = 'yellow'
          break
        case 'Onsite G3':
          color = 'blue'
          break
      }
      return color
    }
  },
  computed: {
    dateYear() {
      return this.date.getYear()
    },
    dataTable () {
      let data = []
      if (this.userLog !== null) {
        this.userLog.forEach(u => {
          let obj = {
            name: `${u.firstName} ${u.lastName}`,
            time: u.updatedAt.toDate(),
            status: u.status
          }
          data.push(obj)
        })
      }
      return data
    }
  },
  firestore () {
    return {
      userLog: db.collection('userLogs').orderBy('updatedAt').where('updatedAt', '>', new Date(this.date))
    }
  },
  watch: {
    // whenever date changes, this function will run
    date: function (newDate) {
      console.log('does this fire')
      let today = new Date(newDate)
      let tomorrow = new Date(today)
      tomorrow.setDate(today.getDate() + 1)
      today.setHours(0,0,0,0)
      tomorrow.setHours(0,0,0,0)
      this.dateReady = false
      this.$bind('userLog', db.collection('userLogs').where('updatedAt', '>=', today).where('updatedAt', '<=', tomorrow))
      .then((doc) => {
        this.dataReady = true
      })
      .catch((error) => {
        console.log('error in loading: ', error)
      })
    }
  },
  mounted () {
    console.log('Loaded into')
    let today = new Date()
    let tomorrow = new Date()
    tomorrow.setDate(today.getDate() + 1)
    today.setHours(0,0,0,0)
    tomorrow.setHours(0,0,0,0)
    console.log(tomorrow, today.getDate())
    this.$bind('userLog', db.collection('userLogs').where('updatedAt', '>=', today).where('updatedAt', '<=', tomorrow))
      .then((doc) => {
        console.log('data ready')
        this.dataReady = true
      })
      .catch((error) => {
        console.log('error in loading: ', error)
      })
  },
  filters: {
    moment: (date) => {
      return moment(date).format('MMM Do YYYY h:mm:ss a')
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Log.vue